// Dependencies
import { useTranslation } from 'react-i18next';
import React, { FC, ReactElement, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// Core & Lab
import Grid from '@mui/material/Grid';
import Checkbox from '@mui/material/Checkbox';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
// Actions
import { updateStocksEditMode } from './redux/reducer';
import { setFinished } from '../utils/finished/redux/actions';
// Types
import { AppState } from '../../reducers';

const ChannelManagerStockEditClosedSale: FC = (): null => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const stocks_closed_sale_room_id = useSelector((state: AppState) => state.channelManager.stocks_closed_sale_room_id);
    const stocks_closed_sale_start_date = useSelector((state: AppState) => state.channelManager.stocks_closed_sale_start_date);
    const stocks_closed_sale_end_date = useSelector((state: AppState) => state.channelManager.stocks_closed_sale_end_date);
    const channel_manager = useSelector((state: AppState) => state.channelManager.channel_manager);
    const room_list = useSelector((state: AppState) => state.channelManager.room_list);
    const onUpdateClosedSale = () => {
        if (channel_manager !== null && stocks_closed_sale_start_date !== null && stocks_closed_sale_end_date !== null) {
            dispatch(setFinished(true));
            room_list.map(room => {
                if (room.id === stocks_closed_sale_room_id) {
                    let black_outs: {}[] = [];
                    room.black_out.map(black_out => {
                        if (black_out.date !== null) {

                        } else if (black_out.start_date !== null && black_out.end_date) {
                            if (stocks_closed_sale_start_date >= new Date(black_out.start_date).setHours(0,0,0,0) && stocks_closed_sale_start_date <= new Date(black_out.end_date).setHours(0,0,0,0)) {

                            }
                        }
                    });
                }
            });
        }
    };
    useEffect(() => {
        // onUpdateClosedSale();
    }, [stocks_closed_sale_start_date, stocks_closed_sale_end_date]);
    return null;
};

export default ChannelManagerStockEditClosedSale;